import { getLocalizedPath } from '@main/internationalization';
import { clearPrivacyCenter } from '@main/privacy-center/src/containers/App/slice';
import { LanguageKey } from '@transcend-io/internationalization';
import React from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { IToggleOption, LocalePopover } from './LocalePopover';
import { selectMessages } from './messages';

/**
 * LocaleToggle props
 */
export interface ILocaleToggleProps {
  /** The languages to toggle */
  options: IToggleOption[];
}

/**
 * LocaleToggle to change the language
 */
export function LocaleToggle({ options }: ILocaleToggleProps): JSX.Element {
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const { formatMessage, locale } = useIntl();

  return (
    <LocalePopover
      id="locale-toggle"
      onToggle={(value) => {
        dispatch(clearPrivacyCenter());
        window.location.pathname = getLocalizedPath(pathname, value);
      }}
      currentValue={locale as LanguageKey}
      options={options}
      label={formatMessage(selectMessages.label)}
    />
  );
}

export default LocaleToggle;
